export const CS_EMPLOYEE_DAILY_PERFORMANCE_PATH =
  "/customer-service/charts/dailyPerformance";

export const CS_DAILY_PERFORMANCE_REPORT_PATHS = [
  "/admin/charts/dailyPerformanceForCustomerService",
  "/customer-service-supervisor/charts/dailyPerformanceForCustomerService",
  CS_EMPLOYEE_DAILY_PERFORMANCE_PATH,
];

export function isCsDailyPerformanceReportPath(pathname = "") {
  return CS_DAILY_PERFORMANCE_REPORT_PATHS.includes(pathname);
}

export function isCsEmployeeSelfDailyReportRoute(route) {
  if (!route) {
    return false;
  }

  return (
    route.meta?.cs_daily_report_self === 1 ||
    route.name === "csEmployeeDailyReport" ||
    route.path === CS_EMPLOYEE_DAILY_PERFORMANCE_PATH
  );
}

export function getLoggedInCsEmployeeId() {
  if (typeof localStorage === "undefined") {
    return null;
  }

  const id = localStorage.getItem("id");
  return id ? Number(id) : null;
}

/** Force CS employee report to query only the logged-in user */
export function appendSelfCsAdviserFilter(formData, agentId = getLoggedInCsEmployeeId()) {
  if (!formData || !agentId || typeof formData.append !== "function") {
    return formData;
  }

  formData.append("adviser_id[0]", String(agentId));
  return formData;
}
